import React from 'react';
import { Reveal } from '../motion/Reveal';
import { Camera, Send, ShieldCheck, Landmark, TrafficCone } from 'lucide-react';

const STEPS = [
    { icon: Camera, title: 'Capture Evidence', desc: 'Photograph or record the violation with your phone.' },
    { icon: Send, title: 'Submit Report', desc: 'Add the vehicle number and location, then submit in seconds.' },
    { icon: ShieldCheck, title: 'Verification', desc: 'A traffic officer reviews the evidence for accuracy.' },
    { icon: Landmark, title: 'Forwarded to Authorities', desc: 'Verified reports are sent to the official system.' },
    { icon: TrafficCone, title: 'Safer Roads', desc: 'Accountability grows and your city drives more responsibly.' },
];

/** "How it works" — 5-step flow. Horizontal on desktop, vertical on mobile. */
export default function HowItWorks() {
    return (
        <section
            id="how-it-works"
            className="scroll-mt-20 py-20 sm:py-24 bg-grad-sky"
            aria-labelledby="how-title"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <Reveal className="text-center max-w-2xl mx-auto mb-14">
                    <p className="overline mb-2">The process</p>
                    <h2 id="how-title" className="font-heading font-bold text-3xl sm:text-4xl tracking-tight">
                        How it works
                    </h2>
                    <p className="mt-3 text-muted-foreground text-lg">
                        From evidence to enforcement in five simple steps — most reports take under a minute.
                    </p>
                </Reveal>

                <Reveal stagger className="relative grid gap-8 md:grid-cols-5">
                    {/* connecting line (desktop) */}
                    <div className="hidden md:block absolute top-7 left-[10%] right-[10%] h-0.5 bg-border" aria-hidden="true" />

                    {STEPS.map(({ icon: Icon, title, desc }, i) => (
                        <Reveal.Item key={title} className="relative text-center">
                            <div className="relative z-10 mx-auto w-14 h-14 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center shadow-sm">
                                <Icon className="w-6 h-6" aria-hidden="true" />
                                <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-card border text-foreground text-xs font-bold flex items-center justify-center">
                                    {i + 1}
                                </span>
                            </div>
                            <h3 className="font-heading font-semibold text-base mt-4">{title}</h3>
                            <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed">{desc}</p>
                        </Reveal.Item>
                    ))}
                </Reveal>
            </div>
        </section>
    );
}
